import { render } from "./OpenInNew.vue?vue&type=template&id=d507caf2"
import script from "./OpenInNew.vue?vue&type=script&lang=js"
export * from "./OpenInNew.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__